import React from 'react'

function OurDoctors() {
  return (
    <div>OurDoctors</div>
  )
}

export default OurDoctors